import React from 'react';
import TextField from './TextField';
import isNumber from 'is-number';

const validateNumber = required => value => {
  if (value === '' && required) {
    return 'forms.number_required';
  }

  if (!isNumber(+value)) {
    return 'forms.number_required';
  }

  return undefined;
};

export default function Number(props) {
  return (
    <TextField
      type="number"
      validate={validateNumber(props.required)}
      // ensures that Formik only gets number values when valid
      transformValue={v => (isNumber(v) ? +v : v)}
      {...props}
    />
  );
}
